/*
 * @Author: stevensh
 * @Date: 2020-03-02 15:27:24
 * @Last Modified by: stevensh
 * @Last Modified time: 2020-06-12 09:52:18
 */

import { action, observable } from 'mobx';
import { message } from 'antd';
import { getUrlParams } from 'utils/helper';
import { setCookie, getCookie } from 'utils/cookie';
import storeMgr from 'utils/storeManager';

import {
  authorization,
  installApp,
  getCollection,
  getPlatform,
} from './service';
import { IUserInfo } from './interface';

export const moduleName = 'frame';

export interface IStore {
  loading: boolean;
  collectionas: any | null;
  platforms: Array<string>;
  init(): void;
  getUserInfo(): void;
}

class Store implements IStore {
  @observable public loading: boolean;
  @observable public collectionas = null;
  @observable public platforms: Array<string> = [];
  @action
  public init = () => {
    this.loading = true;

    const urlParams = getUrlParams();

    if (urlParams) {
      if (urlParams && urlParams['response']) {
        this.installApp(urlParams);
      } else {
        this.authorization(urlParams);
      }
    } else {
      const token = getCookie('shopify-sino-accessToken');

      if (token) {
        //已有token，
        this.getUserInfo();
      } else {
        //没有token，获取token流程
        // console.log('未取到');
        window.location.href = '//accounts.shopify.com/store-login';
      }
    }
  };

  private authorization = async params => {
    let obj = { ...params, app_name: 'tracking' };

    if (!obj.redirect_uri) {
      obj.redirect_uri = window.location.origin;
    }
    const res = await authorization(obj);

    const { success, data } = res;

    if (success) {
      const { url, token } = data;

      console.log('data', data);
      if (token) {
        // window.location.href = url;
        setCookie('shopify-sino-accessToken', token, 2);
        this.getUserInfo();
      } else {
        window.location.href = url;
      }
    } else {
      message.error('接口报错');
    }
  };

  private installApp = async params => {
    const res = await installApp(params);
    const { success, data } = res;
    if (success) {
      const { token } = data;
      setCookie('shopify-sino-accessToken', token, 2);

      this.getUserInfo();
    } else {
      message.error('接口报错');
    }
  };

  public getUserInfo = async () => {
    const res = await getCollection();
    const resPlatform = await getPlatform();
    const { success, data } = res;
    const { data: platforms } = resPlatform;
    if (success) {
      this.collectionas = data;
    }
    this.platforms = platforms;
    this.loading = false;
    return true;
  };
}

storeMgr.register(moduleName, new Store());
